import React from "react";
import { MainScreen } from "./screens/main";
import { HeroUIProvider } from "@heroui/react";
export const App = () => {
    return (React.createElement(HeroUIProvider, null,
        React.createElement(MainScreen, null)));
    // return <MainTestScreen />;
};
